import { takeEvery } from 'redux-saga/effects';
import { ATTACHMENT_DELETE_ATTACHMENTS } from '../actions';
import { deleteAttachmentsSaga } from './deleteAttachmentsSaga';
export const attachmentRootSaga = [takeEvery([ATTACHMENT_DELETE_ATTACHMENTS], deleteAttachmentsSaga)];
//# sourceMappingURL=attachmentRootSaga.js.map